export type ApiErrorKind =
  | 'AUTH_REQUIRED'
  | 'AUTH_EXPIRED'
  | 'FORBIDDEN'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'VALIDATION'
  | 'NETWORK'
  | 'TIMEOUT'
  | 'SERVER'
  | 'CONFIG'
  | 'INVALID_RESPONSE'
  | 'BUSINESS'
  | 'CANCELLED'
  | 'UNKNOWN'

export interface ApiErrorOptions {
  status?: number
  businessCode?: number | string
  serverMessage?: string
  cause?: unknown
}

export class ApiError extends Error {
  readonly kind: ApiErrorKind
  readonly status?: number
  readonly businessCode?: number | string
  readonly serverMessage?: string
  readonly cause?: unknown

  constructor(kind: ApiErrorKind, message: string, options: ApiErrorOptions = {}) {
    super(message)
    this.name = 'ApiError'
    this.kind = kind
    this.status = options.status
    this.businessCode = options.businessCode
    this.serverMessage = options.serverMessage
    this.cause = options.cause
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError

export const isAuthError = (error: unknown): boolean =>
  isApiError(error) && (error.kind === 'AUTH_REQUIRED' || error.kind === 'AUTH_EXPIRED')

export const isCancelledError = (error: unknown): boolean => isApiError(error) && error.kind === 'CANCELLED'
